import Service, { type Registry as Services, service } from '@ember/service';
import {
  type Filter,
  ClientNameFilter,
  PropertyFilter,
  AirbnbQualityStateFilter,
  AirbnbConnectionFilter,
  AirbnbLinkFilter,
  ClientStatementStatusFilter,
  MonthFilter,
  UpsellOrderStatusFilter,
  ClientStatementPaymentStatusFilter,
  AirbnbCancellationPolicyFilter,
  CountryFilter,
  CityFilter,
  KnowledgeCenterCategoryFilter,
  KnowledgeCenterStatusFilter,
  ProtectionStatusFilter,
  BookingWindowFilter,
  DisputeStatusFilter,
} from 'uplisting-frontend/utils/filters/types';
import { FilterId } from 'uplisting-frontend/utils/filters/abstract';

export default class FiltersService extends Service {
  @service store!: Services['store'];

  public createFilterFor(id: FilterId, value?: string | string[]): Filter {
    const filter = this.createFilterById(id, value);

    this.attachStore(filter);

    return filter;
  }

  private createFilterById(id: FilterId, value?: string | string[]): Filter {
    switch (id) {
      case FilterId.clientName:
        return new ClientNameFilter(value as string[]);
      case FilterId.property:
        return new PropertyFilter(value as string[]);
      case FilterId.airbnbQualityState:
        return new AirbnbQualityStateFilter(value as string[]);
      case FilterId.airbnbOfficialLink:
        return new AirbnbLinkFilter(value as string[]);
      case FilterId.airbnbOfficialConnection:
        return new AirbnbConnectionFilter(value as string[]);
      case FilterId.clientStatementStatus:
        return new ClientStatementStatusFilter(value as string);
      case FilterId.clientStatementPaymentStatus:
        return new ClientStatementPaymentStatusFilter(value as string);
      case FilterId.period:
        return new MonthFilter(value as string);
      case FilterId.upsellOrderStatus:
        return new UpsellOrderStatusFilter(value as string);
      case FilterId.airbnbCancellationPolicy:
        return new AirbnbCancellationPolicyFilter(value as string[]);
      case FilterId.country:
        return new CountryFilter(value as string[]);
      case FilterId.city:
        return new CityFilter(value as string[]);
      case FilterId.knowledgeCenterCategory:
        return new KnowledgeCenterCategoryFilter(value as string[]);
      case FilterId.knowledgeCenterStatus:
        return new KnowledgeCenterStatusFilter(value as string[]);
      case FilterId.protectionStatus:
        return new ProtectionStatusFilter(value as string[]);
      case FilterId.bookingWindow:
        return new BookingWindowFilter(value as string);
      case FilterId.disputeStatus:
        return new DisputeStatusFilter(value as string[]);
      default:
        throw new Error(
          `unknown filter id, expected to be 'FilterId', got ${id}`,
        );
    }
  }

  private attachStore(filter: Filter): void {
    filter.store = this.store;
  }
}

declare module '@ember/service' {
  interface Registry {
    filters: FiltersService;
  }
}
